<script setup lang="ts">
import { type PropType } from 'vue'
import { TYPE_STORY, type LifeFileDTO, type MemorialPostDTO } from '@/composables/memorize/memorize'
import { isNotEmpty, isEmpty, minifyString } from '@/utils/util'
import { useRouter } from 'vue-router'
import { titleBar } from '@/composables/menu/title'
import { isSetRealName } from '@/composables/user/users'
const props = defineProps({
  name: {
    type: String,
    default: ''
  },
  serviceId: {
    type: String,
    default: ''
  },
  post: {
    type: Object as PropType<MemorialPostDTO | undefined>,
    default: () => undefined
  },
  canManage: {
    type: Boolean,
    required: true
  }
})

const router = useRouter()

function toStory() {
  router.push(`/m/${props.serviceId}/story?postId=${props.post.id}`)
}
const emit = defineEmits(['showSetRealNameDialog'])
function handleCreate() {
  if (!isSetRealName.value) {
    emit('showSetRealNameDialog')
    return
  }
  router.push(
    `/addPhoto?type=${TYPE_STORY}&serviceId=` + props.serviceId + '&name=' + titleBar.value?.life?.name.fullName
  )
}
</script>

<template>
  <div class="w-11/12 md:w-full" flex="~ row" bg-theme-light rounded-3 overflow-hidden p-4 bg-theme-gray>
    <div class="w-7/12" rounded-2 h-36 flex flex-col items-start justify-start pr-2 overflow-hidden>
      <div
        v-if="isNotEmpty(props.post?.content)"
        v-html="props.post?.content"
        :class="props.post?.files?.length > 0 ? 'line-clamp-1' : 'line-clamp-5'"
        font-normal
        text-sm
        text-theme-gray
        leading-6.5
        @click="toStory"></div>
      <ImageGrid
        v-if="props.post && props.post?.files && props.post?.files?.length > 0"
        :files="props.post?.files"
        :class="isNotEmpty(props.post?.content) ? 'mt-2' : ''"
        @onMediaClick="toStory" />
      <div v-if="isEmpty(props.post)" w-full h-full flex="~ row" items-center justify-center>
        <div text-theme-gray text-sm>{{ $t('m.slide_no_story') }}</div>
      </div>
    </div>
    <div flex="~ col" px-2>
      <h3 text-theme-main font-bold @click="$router.push(`/m/${props.serviceId}/story`)" cursor-pointer>
        {{ $t('m.slide_ones_story', { name: minifyString(props.name, 12) }) }}
      </h3>
      <button v-if="props.canManage" btn-theme-outline text-xs my-0.5 mt-10 border-1px opacity-70 @click="handleCreate">
        {{ $t('m.slide_add_story') }}
      </button>
    </div>
  </div>
</template>

<style scoped>
/* style */
/* 添加模糊过渡动画 */
.blur-layer {
  transition: filter 0.3s ease;
}

/* 优化模糊层性能 */
@media (prefers-reduced-motion: no-preference) {
  .blur-layer {
    will-change: filter;
  }
}

/* 移动端优化 */
@media (max-width: 768px) {
  .blur-layer {
    filter: blur(8px); /* 减小模糊强度 */
  }
}
</style>
